// Declared twice so that docs appear when selecting colors
interface GrayPalette extends Record<string, string> {
  /** **#F8F8F8** - Optional table  */
  readonly gray0: string;
  /** **#FAFAFB** - Formerly named "smoke". Full page background, hover on table row */
  readonly gray5: string;
  /** **#F1F1F2** - Formerly named "heather". Background sections, table headers */
  readonly gray10: string;
  /** **#E9E9EA** - Formerly named "sterling". Subtle table lines, selected gray on gray, card shadow */
  readonly gray20: string;
  /** **#E2E2E3** - Formerly named "gray". Lines within a table, content on white */
  readonly gray30: string;
  /** **#D1CFCF** - Formerly named "pearl". Separation line */
  readonly gray40: string;
  /** **#C4C4C5** - Formerly named "stone". Disabled icons, checkboxes */
  readonly gray45: string;
  /** **#A0A0A3** - Formerly named "ash". Deselected text, line on gray */
  readonly gray50: string;
  /** **#7B7B7E** - Formerly named "koala". Secondary text on black or white */
  readonly gray60: string;
  /** **#5A5A5D** - Formerly named "raven". Selected side navigation */
  readonly gray70: string;
  /** **#3E3E3F** - Formerly named "charcoal". Side navigation */
  readonly gray80: string;
  /** **#262627** - Formerly named "jet". Large area on black/line separating pages in side nav */
  readonly gray90: string;
  /** **#000000** - Formerly named "black". Text, icons, line */
  readonly gray100: string;
}

export const grayPalette: GrayPalette = {
  gray0: '#F8F8F8',
  gray5: '#FAFAFB',
  gray10: '#F1F1F2',
  gray20: '#E9E9EA',
  gray30: '#E2E2E3',
  gray40: '#D1CFCF',
  gray45: '#C4C4C5',
  gray50: '#A0A0A3',
  gray60: '#7B7B7E',
  gray70: '#5A5A5D',
  gray80: '#3E3E3F',
  gray90: '#262627',
  gray100: '#000000',
};
